import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { runtimeCss as _runtimeCss, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
import React from 'react';
import { useGridContext } from './context';
type Row = HtmlPropsNoRef<HTMLDivElement>;
const Row = (props: Row): JSX.Element => {
  const {
    sortedBreakpoints: outerBreakpoints
  } = useGridContext();
  const css = React.useMemo(() => Object.fromEntries(outerBreakpoints.map(([, {
    query,
    gap,
    columns
  }]) => [query, {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridAutoFlow: 'dense',
    gridColumnGap: `${gap}px`
  }])), [outerBreakpoints]);
  return <div {..._mergeProps({
    css: _runtimeCss({
      ...css,
      width: '100%',
      margin: 'auto',
      position: 'relative'
    }),
    className: "__row"
  }, props)} />;
};
export default Row;